import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, computed } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import DatePicker from "@/components/widgets/input/DatePicker.vue"
import CountrySelect from "@/components/widgets/input/CountrySelect.vue"
import { gender, APPLICANT_ID_KEY } from "@/components/apply/shared/constants"
import PhoneNumberInput from "@/components/widgets/input/PhoneInput.vue"
import {
  UpdateApplicantProfileMutation,
  UpdateApplicantProfileMutationMutation,
  UpdateApplicantProfileMutationMutationVariables,
  UploadFileInput,
  ApplicantProfileInput,
  Applicant,
  UploadFile,
} from "@/gql"

import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { watch } from "vue"

type Files = {
  cv: UploadFile | null
  coverLetter: UploadFile | null
  universityCertificate: UploadFile | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfo',
  props: {
  applicant: {
    type: Object as PropType<Applicant>,
    required: false,
  },
},
  emits: ["save"],
  setup(__props, { emit }) {

const props = __props



const { mutate } = useMutation()
const { addSuccess } = useNotification()
const isSubmitting = ref(false)
const applicantId = localStorage.getItem(APPLICANT_ID_KEY) || ""



const applicant = ref<Applicant | null>(null)

watch(
  () => props.applicant,
  (value) => {
    applicant.value = value as Applicant

    form.value.firstName = applicant.value?.firstName || ""
    form.value.lastName = applicant.value?.lastName || ""
    form.value.gender = applicant.value?.gender || ""
    form.value.emailAddress = applicant.value?.emailAddress || ""
    form.value.city = applicant.value?.city || ""
    form.value.jobRole = applicant.value?.jobRole || ""
    form.value.phone = {
      countryCode: applicant.value?.phoneCountryCode || "",
      number: applicant.value?.phoneNumber || "",
    }
    form.value.dateOfBirth = applicant.value?.dateOfBirth || ""
    form.value.countryId = applicant.value?.country?.id || 0

    files.value.cv = applicant.value?.cv || null
    files.value.coverLetter = applicant.value?.coverLetter || null
    files.value.universityCertificate = applicant.value?.certificate || null
  }
)

const form = ref<ApplicantProfileInput>({
  firstName: "",
  lastName: "",
  gender: "",
  emailAddress: "",
  city: "",
  jobRole: "",
  phone: {
    countryCode: "",
    number: "",
  },
  dateOfBirth: "",
  countryId: 0,
})

const files = ref<Files>({
  cv: null,
  coverLetter: null,
  universityCertificate: null,
})

const applicantDocuments = computed(() => {
  const documents = []

  if (files.value.cv) documents.push(files.value.cv)
  if (files.value.coverLetter) documents.push(files.value.coverLetter)
  if (files.value.universityCertificate) documents.push(files.value.universityCertificate)

  return documents.filter((doc) => !doc.id) as unknown as UploadFileInput[]
})

const observer = ref(null)

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()

  if (!validity.isValid) return
  if (!applicantId) return

  isSubmitting.value = true

  // Mutate
  const result = await mutate<
    UpdateApplicantProfileMutationMutation,
    UpdateApplicantProfileMutationMutationVariables
  >({
    mutation: UpdateApplicantProfileMutation,
    variables: {
      applicantId,
      profile: form.value,
      applicantDocuments: applicantDocuments.value,
    },
    handlePayloadErrors: true,
  })

  // Done
  if (result?.data?.updateApplicantProfile.applicant?.id) {
    addSuccess("Applicant information updated")
    emit("save")
  }

  isSubmitting.value = false
}

return { __sfc: true,props, mutate, addSuccess, isSubmitting, applicantId, emit, applicant, form, files, applicantDocuments, observer, onSubmit, AppPage, DatePicker, CountrySelect, gender, PhoneNumberInput }
}

})